import { Device as CapacitorDevice } from "@capacitor/device"
import { registerIngenicoPlugin } from "./utils/registerIngenicoPlugin"

type GetInfoReturn = {
  name?: string
  model: string
  platform: "ios" | "android" | "web"
  operatingSystem:
    | "ios"
    | "android"
    | "windows"
    | "mac"
    | "unknown"
  osVersion: string
  androidSDKVersion?: number
  manufacturer: string
  isVirtual: boolean
  memUsed?: number
  diskFree?: number
  diskTotal?: number
  realDiskFree?: number
  realDiskTotal?: number
  webViewVersion: string
}
type GetBatteryInfoReturn = {
  batteryLevel?: number
  isCharging?: boolean
}
export type IDevicePlugin = {
  getInfo: () => Promise<GetInfoReturn>
  getBatteryInfo: () => Promise<GetBatteryInfoReturn>
}

export const IDevice: IDevicePlugin =
  import.meta.env.VITE_PLATFORM === "ingenicoNerpay"
    ? registerIngenicoPlugin<IDevicePlugin>("IDevicePlugin")
    : CapacitorDevice
